<div class="row" *ngIf="hasUnansweredComment">
  <div  class="offset-1 col-8">
    <div class="comments-section"
         *ngFor="let comment of discussions[0].comments">
      <span>{{ translationPrefix + 'adminComments' | translate }}:<br>
        <small *ngIf="comment.commentTimestampStr">
          ({{ translationPrefix + 'timestamp' | translate }}: {{ comment.commentTimestampStr }})
        </small>
      </span>
      <span>
        {{ comment.comment}}
      </span>
    </div>
  </div>
</div>

<div ngbAccordion [closeOthers]="true"  [animation]="false" *ngIf="anyPreviousDiscussions">
  <div ngbAccordionItem="p1"
  (show)="onPanelShown('p1')" (hide)="onPanelHidden('p1')"
  >
    <div ngbAccordionHeader class="accordion-button custom-header">
      <button ngbAccordionButton class="btn btn-transparent" aria-label="Toggle">
        <fa-icon [icon]="['fas', openPanelStates['p1'] ? 'chevron-down' : 'chevron-up']"></fa-icon>
      </button>
      <h2 class="ml-2 d-inline">{{ translationPrefix + 'previousDiscussion' | translate }}</h2>
    </div>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="offset-1 col-8">
            <ng-container *ngFor="let discussion of discussions">
              <ng-container *ngIf="discussion.userComment">
                <div class="comments-section section-start">
                  <span>{{ translationPrefix + 'response' | translate }}:<br>
                    <small>({{ translationPrefix + 'timestamp' | translate }}: {{ discussion.userCommentTimestampStr }})</small>
                  </span>
                  <span>
                    {{ discussion.userComment }}
                  </span>
                </div>
                <div class="comments-section" *ngFor="let comment of discussion.comments">
                  <span>{{ translationPrefix + 'adminComments' | translate }}:<br>
                    <small>({{ translationPrefix + 'timestamp' | translate }}: {{ comment.commentTimestampStr }})</small>
                  </span>
                  <span>
                    {{ comment.comment }}
                  </span>
                </div>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="customContent">
              <ng-content></ng-content>
            </ng-container>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

